import React from "react";
import NavigationCard from './navigationCard';
import SubNavigationItem from './subNavigationItem';

const MainNavigationItem = (navItem, index) => {

  const {title, navigationCard, subNavigations} = navItem;

  return ([
    <button className="navigation--item__link" key={`navigation-item-link` + index}>
        {title}
        <i>
            <svg width="13" height="8" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fillRule="evenodd" clipRule="evenodd" d="M10.6161 1.49999C10.8602 1.25591 11.2559 1.25591 11.5 1.49999C11.7441 1.74406 11.7441 2.13979 11.5 2.38387L7.20709 6.67676C6.81657 7.06729 6.1834 7.06729 5.79288 6.67676L1.49999 2.38387C1.25591 2.13979 1.25591 1.74406 1.49999 1.49999C1.74406 1.25591 2.13979 1.25591 2.38387 1.49999L5.79288 4.909C6.1834 5.29952 6.81657 5.29952 7.20709 4.909L10.6161 1.49999Z" fill="#52288E" stroke="#52288E"/>
            </svg>
        </i>
    </button>,
    <div className={`navigation--item__subnavigation`} key={`navigation-item-subnavigation`+index}>
        <div className="scroll-area">
            <ul>
                {SubNavigationItem(subNavigations)}
                {navigationCard && NavigationCard(navigationCard)}
            </ul>
        </div>
    </div>
  ])
}

export default MainNavigationItem